import { EyeOutlined } from "@ant-design/icons";
import { Button, Card, Switch, Table } from "antd";

export default function CategoryManagementCard({
  categories,
  selectedId,
  handleSelectCategory,
  manageCategoryItem,
  getCategoryConfig,
  disabled,
}) {
  const handleVisibilityChange = (category, isVisible, event) => {
    event.stopPropagation();
    manageCategoryItem({
      method: "PUT",
      body: {
        isRemoved: !isVisible,
        id: category.id,
        table: "MerchantCategoryLinks",
      },
      onSuccessCallback: () => getCategoryConfig(true),
    });
  };

  const categoryColumns = [
    { title: "Category Name", dataIndex: "name" },
    {
      key: "items",
      title: "No. of Items",
      render: (_, record) => record.items.length,
    },
    {
      title: "Visibility",
      render: (_, record) => (
        <Switch
          checked={!record.isRemoved}
          onChange={(checked, event) =>
            handleVisibilityChange(record, checked, event)
          }
          checkedChildren="Visible"
          unCheckedChildren="Hidden"
        />
      ),
    },
    {
      title: "Action",

      render: (_, record) => (
        <Button
          type="primary"
          icon={<EyeOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            handleSelectCategory(record.id);
          }}
        >
          Manage
        </Button>
      ),
    },
  ];

  return (
    <Card title="Food Configuration" style={{ height: "100%" }}>
      <Table
        rowKey="id"
        columns={categoryColumns}
        dataSource={categories}
        pagination={{ pageSize: 10 }}
        rowClassName={(record) => {
          let className = "cursor-pointer";
          if (disabled) className += " ant-table-row-disabled";
          if (record.id === selectedId) className += " ant-table-row-selected";
          return className;
        }}
        onRow={(record) => ({
          onClick: () => !disabled && handleSelectCategory(record.id),
        })}
        scroll={{ y: "calc(100vh - 255px)" }}
      />
      <style>{`.ant-table-row-disabled { cursor: not-allowed !important; }`}</style>
    </Card>
  );
}
